
<div class="flex items-center justify-center min-h-full p-4">
  <div class="w-full max-w-md">
    <div class="text-center mb-8">
       <h1 class="text-3xl font-extrabold text-white font-brand tracking-wider">
        <i class="fa-solid fa-shield-halved mr-2 text-emerald-400"></i>
        New Password
      </h1>
      <p class="text-slate-400 mt-2 text-sm">ตั้งรหัสผ่านใหม่ของคุณ</p>
    </div>

    <div class="bg-slate-800/80 backdrop-blur-sm shadow-2xl rounded-2xl p-8 border border-slate-700">
      
      @if (errorMessage()) {
        <div class="bg-red-900/50 border border-red-500 text-red-200 px-4 py-3 rounded-lg text-sm flex items-start gap-2 animate-pulse mb-6">
            <i class="fa-solid fa-circle-exclamation mt-0.5"></i>
            <span>{{ errorMessage() }}</span>
        </div>
      }

      <form [formGroup]="updateForm" (ngSubmit)="onSubmit()">
        <div class="space-y-5">
          
          <div>
            <label for="password" class="block text-sm font-medium text-slate-300 mb-1">รหัสผ่านใหม่ (New Password)</label>
            <div class="relative">
                <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                    <i class="fa-solid fa-lock"></i>
                </span>
                <input 
                    [type]="showPassword() ? 'text' : 'password'"
                    formControlName="password" id="password" 
                    class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-10 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600" 
                    placeholder="อย่างน้อย 6 ตัวอักษร">
                 <button type="button" (click)="togglePassword()" class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-500 hover:text-slate-300 focus:outline-none">
                    <i class="fa-solid" [class]="showPassword() ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
            </div>
          </div>

          <div>
            <label for="confirmPassword" class="block text-sm font-medium text-slate-300 mb-1">ยืนยันรหัสผ่าน (Confirm Password)</label>
            <div class="relative">
                <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-500">
                    <i class="fa-solid fa-lock"></i>
                </span>
                <input 
                    [type]="showConfirmPassword() ? 'text' : 'password'"
                    formControlName="confirmPassword" id="confirmPassword" 
                    class="w-full bg-slate-900 border border-slate-600 rounded-lg py-3 pl-10 pr-10 text-slate-200 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all placeholder-slate-600" 
                    placeholder="พิมพ์รหัสผ่านอีกครั้ง">
                <button type="button" (click)="toggleConfirmPassword()" class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-500 hover:text-slate-300 focus:outline-none">
                    <i class="fa-solid" [class]="showConfirmPassword() ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
            </div>
            @if (updateForm.hasError('mismatch') && updateForm.get('confirmPassword')?.touched) {
              <p class="text-red-400 text-xs mt-1">รหัสผ่านไม่ตรงกัน</p>
            }
          </div>

          <button type="submit" [disabled]="updateForm.invalid || isLoading()"
            class="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-lg shadow-lg transition-all transform active:scale-95 disabled:bg-slate-600 disabled:cursor-not-allowed disabled:transform-none mt-4">
            @if (isLoading()) {
              <i class="fa-solid fa-spinner animate-spin"></i>
              <span>Saving...</span>
            } @else {
              <span>เปลี่ยนรหัสผ่าน (Update Password)</span>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
